import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $slug: [String], $draftId: Int, $revisionId: Int) {
        data: entry(section: "programGuide", siteId: $siteId, slug: $slug, draftId: $draftId, revisionId: $revisionId) {
            id
            status
            title
            ... on programGuide_Entry {
                seoMetaTitle
                seoMetaDescription
                userStatus
                leader: html
                message: string
                programDownloadCsv
                programDownloadPdf
                programGuideSessionTypeTerm
                leaderboardAdProgramGuide
                comingSoon: lightswitchDefaultOff
                showEmailForm: lightswitchDefaultOn
                singlesMatrix {
                    ... on pageTitle_Entry {
                        type: typeHandle
                        pageTitle
                    }
                    ... on html_Entry {
                        type: typeHandle
                        body
                        cssClasses
                        fullWidth
                    }
                    ... on body_Entry {
                        type: typeHandle
                        body
                        backgroundImage {
                            url
                        }
                        backgroundImageMobile {
                            url
                        }
                        bgMobileBreakpoint
                        backgroundColor
                        fullWidth
                        cssClasses
                    }
                    ... on ad_Entry {
                        type: typeHandle
                        ad
                    }
                    ... on emailForm_Entry {
                        type: typeHandle
                        textAbove
                        cssClasses
                    }
                    ... on programGuide2_Entry {
                        type: typeHandle
                        message
                        programGuideVersion
                        programGuideGrouping
                        csvDownload
                        pdfDownload
                        programGuideSessionTypeTerm
                    }
                    ... on atAGlance_Entry {
                        type: typeHandle
                        message
                        atAGlanceEventTextColor
                    }
                    ... on directorsFaculty_Entry {
                        type: typeHandle
                        directorsHeading
                        rolesToSuppress
                    }
                    ... on advancedAgenda_Entry {
                        type: typeHandle
                        showFilters
                        showSearch
                        showDownloadLinks
                        openFirstSessionByDefault
                        expandAllGroups
                        doNotGroup
                        onDemandOnly
                        adjustForStreaming
                        displayType
                        sourceType
                        identifiers
                        excludeSessions
                    }
                    ... on programChatbot_Entry {
                        type: typeHandle
                        title
                        showScheduleBuilder
                        showSidePanel
                        showInlineCards
                        showUserFeatures
                        agentId
                        version
                        startingMessage
                        initialMessages {
                            message
                        }
                    }
                    ... on customComponent_Entry {
                        type: typeHandle
                        component
                        customClass
                        json
                        contentBlox: contentBlocks {
                            ... on contentBlocksBlock_Entry {
                                block: contentBlock
                            }
                        }
                        parameters {
                            value
                        }
                    }
                }
            }
        }
    }
`
